import type { Delivery, PoKind, PurchaseOrderData } from './po';

/**
 * Recepția de pe șantier (cerută de proprietar, 2026-10-16): omul cu rolul
 * „Șantier” are avizul în mână, deci el trece livrarea, cu poza avizului.
 * Achizițiile o confirmă după. El vede comanda doar cât îi trebuie la poartă:
 * furnizorul, ce vine, când și unde. Niciun preț.
 */

/** O poziție a comenzii, fără preț. */
export interface SiteOrderLine {
  desc: string;
  qty: number;
  unit: string;
  /** chirie: la sfârșit pleacă înapoi, cu retur */
  rent: boolean;
}

/** Comanda emisă, cum o vede contul de șantier. */
export interface SiteOrder {
  id: string;
  rfqId: string;
  number: string;
  kind: PoKind;
  title: string;
  site: { id: string; name: string };
  supplierName: string;
  deliveryAddress: string;
  /** 'AAAA-LL-ZZ' sau '' */
  deliveryDate: string;
  lines: SiteOrderLine[];
  /** cererea are chirie: se poate trece și returul */
  rental: boolean;
  /** ISO 8601: marcată „livrată integral”; null = încă vine marfă */
  completedAt: string | null;
  deliveries: Delivery[];
}

/** Doar câmpurile numite aici ajung la șantier: un câmp nou pe comandă nu se scurge singur. */
export function siteOrder(
  o: {
    id: string;
    rfqId: string;
    number: string;
    kind?: PoKind;
    completedAt?: string | null;
    data: PurchaseOrderData;
    deliveries: Delivery[];
  },
  ctx: { siteId: string; rental: boolean },
): SiteOrder {
  return {
    id: o.id,
    rfqId: o.rfqId,
    number: o.number,
    kind: o.kind ?? 'order',
    title: o.data.rfqTitle,
    site: { id: ctx.siteId, name: o.data.siteName },
    supplierName: o.data.supplierName,
    deliveryAddress: o.data.deliveryAddress,
    deliveryDate: o.data.deliveryDate,
    lines: o.data.lines.map((l) => ({
      desc: l.desc,
      qty: l.qty,
      unit: l.unit,
      rent: l.rent != null,
    })),
    rental: ctx.rental,
    completedAt: o.completedAt ?? null,
    deliveries: o.deliveries,
  };
}

/** Trecută de pe șantier și neverificată încă de Achiziții. */
export const toConfirm = (d: Pick<Delivery, 'confirmedAt'>): boolean => !d.confirmedAt;

/** Omul de pe șantier își schimbă sau își șterge livrarea doar până o confirmă cineva. */
export const siteCanChange = (
  d: Pick<Delivery, 'createdBy' | 'confirmedAt'>,
  userId: string,
): boolean => d.createdBy?.id === userId && !d.confirmedAt;
